<!--地图选择-->

<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <el-input v-model="formData.customer_address" placeholder="地址" disabled
                :style="{width: '80%'}"></el-input>
      <el-button v-if="!edit" size="small" style="min-width: 19%;margin-left: 1%" type="primary" @click="select_map">选择</el-button>
    </div>
    <div style="height: 3px"></div>
    <el-input disabled v-model="formData.customer_main_address" placeholder="详细地址"
              :style="{width: '100%'}"></el-input>
    <div>
      <el-dialog
        :visible.sync="select_map_status"
        v-if="select_map_status"
        append-to-body
        :show-close="false"
      >


        <div slot="title" style="text-align: right">
          <el-button @click="select_map_status = false" size="mini">关 闭</el-button>
        </div>
        <map-cavers @confirmMapAddress="sure"></map-cavers>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import mapCavers from "./map"

export default {
  props: ["address", 'address_min', 'edit', 'values'],
  components: {
    mapCavers
  },
  name: "select_map",
  data() {
    return {
      is_edit: false,
      select_map_status: false,
      formData: {
        customer_address: "",
        customer_main_address: ""
      }
    }
  },
  mounted() {
    this.is_edit = this.edit || false
    this.formData.customer_address = this.address
    this.formData.customer_main_address = this.address_min

    setTimeout(() => {
      if (this.values && JSON.stringify(this.values) != "{}") {
        this.formData.customer_address = this.values.province + "/" + this.values.city + '/' + this.values.district
        this.formData.customer_main_address = this.values.address
      }
      this.$forceUpdate()
    }, 300)
  },
  methods: {

    set_address(e) {
      this.formData.customer_address = e.province + "/" + e.city + '/' + e.district
      this.formData.customer_main_address = e.address
    },
    select_map() {
      this.select_map_status = true
    },
    sure(addinfo) {

      this.formData.customer_address = addinfo.province + "/" + addinfo.province + "/" + addinfo.district
      this.formData.customer_main_address = addinfo.address
      this.$emit("selectmap", addinfo)
      this.select_map_status = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/select_map.vue